// extracted by mini-css-extract-plugin
export var textInput = "_m6-0";